import React, { useEffect, useRef, useState } from 'react';
// import { Dropdown } from 'react-bootstrap';
//import swal from "sweetalert";
import { IMAGES } from '../../constants/theme';
import { Link, useNavigate } from 'react-router-dom';
import LoginHeader from '../../layouts/loginheader';
import Swal from 'sweetalert2';
import axios from 'axios';
const LandingPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [passcode, setPasscode] = useState('');
    const form = useRef();
    const token = localStorage.getItem('token');
    useEffect(() => {
        if (token !== null) {
            navigate('/')
        }
    }, [])


    const sendEmail = async (e) => {
        e.preventDefault();
        console.log(email);
        const regex = /^[0-9]{6}$/;
        // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        //     Swal.fire({ icon: 'info', text: "Please Provide Valid Email" });
        //     return;
        // }
        if (!regex.test(passcode)) {
            Swal.fire({ text: 'please provide 6 digit passcode', icon: 'info' })
        }
        let data = new FormData();
        // data.append('email', email);
        data.append('passcode', passcode);

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://culinarymedicinesolutions.org/api/auth.php',
            maxRedirects: 0,
            data: data
        };
        try {
            const response = await axios.request(config);
            console.log(JSON.stringify(response.data));
            if (response.data.status === "success") {
                // Swal.fire({ icon: 'success', text: response.data.message });
                localStorage.setItem('token', passcode);
                navigate('/');
            }
            else {
                Swal.fire({ icon: 'error', text: 'please try again ' });
            }
        }
        catch (error) {
            Swal.fire({ icon: 'error', text: 'Please try again' });
        }
    };
    return (
        <>
            <div className="page-wraper" >

                {/* <Header /> */}
                <LoginHeader />
                <div className="page-content bg-white">
                    <section className="appointment-page" data-text="HEALTH" style={{ backgroundImage: "url(" + IMAGES.BgAppoint + ")" }}>
                        <div className="container">
                            <div className="section-head mb-0">
                                {/* <h2 className="title text-center pt-lg-5 mt-lg-5">Welcome to <span className="text-primary">Culinary Medicine </span>Solutions</h2> */}
                                {/* <h4 className="title text-center mt-lg-5">
                                    Thank you for signing up. we have sent you an email with a passcode and the link to access the application please check your email and to proceed
                                </h4> */}
                                <h4 className="title text-center mt-lg-5">Thank you for signing up. We have sent you an email with a passcode and the link to access the website - please check your email and proceed to our website.</h4>
                                <h4 className='title text-center mt-lg-5'>Please save this passcode for future visits to the website until we go live.</h4>
                            </div>
                            {/* <form className="appointment-form dzForm d-flex justify-content-center" ref={form} onSubmit={sendEmail}>
                                <div className='form-group'>
                                    <input className='form-control' type='email' />
                                </div>
                                <button name="submit" type="submit" value="Submit" className="btn btn-primary btn-lg btn-skew"><span>Appointment</span></button>
                            </form> */}
                            <div className="call-action style-1">

                                <div className="inner-content wow fadeInUp" data-wow-delay="0.8s">
                                    <div className="row justify-content-between align-items-center">
                                        {/* <div className="text-center text-lg-start col-xl-6 m-lg-b20">
                                            <h2 className="title">Subscribe To Our Newsletter</h2>
                                            <p>It is a long established fact that a reader will distracted.</p>
                                        </div> */}
                                        <div className="text-center text-lg-end offset-xl-3 col-xl-6">
                                            <form className="dzSubscribe" ref={form} onSubmit={sendEmail}>
                                                <div className="dzSubscribeMsg"></div>
                                                <div className="form-group mb-0">
                                                    {/* <div className="input-group mb-0">
                                                        <div className="input-skew " style={{ border: '2px solid black' }}>
                                                            <input name="dzEmail" required="required" type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter Email Address" />
                                                        </div>

                                                    </div> */}
                                                    <div className="input-group mb-0 pt-lg-4 pt-md-4">
                                                        <div className="input-skew " style={{ border: '2px solid black' }}>
                                                            <input name="passcode" required="required" type="text" className="form-control" value={passcode} onChange={(e) => setPasscode(e.target.value)} placeholder="Enter Passcode" />
                                                        </div>
                                                        <div className="input-group-addon">
                                                            <button name="submit"
                                                                //value="Submit" 
                                                                type="submit" className="btn btn-secondary btn-lg btn-skew"><span>Submit</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {/* <div className="input-group-addon pt-lg-4 pt-md-4 d-flex justify-content-center align-items-center" >
                                                        
                                                    </div> */}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div >
                <footer className="site-footer style-1 bg-img-fix footer-action" id="footer">
                    <div className="footer-bottom">
                        <div className="text-center">
                            <span className="copyright-text">Copyright © 2024 <Link to="/"  > Culinary Medicine Solutions. </Link>. All rights reserved.</span>
                        </div>
                    </div>
                </footer>
            </div >
        </>
    );
};

export default LandingPassword;